module.exports={API_KEY:"AIzaSyBbhrv0apCv7iTWindgtI9trRAW9fnac30",AUTH_DOMAIN:"vision-project-pxyz.firebaseapp.com",PROJECT_ID:"vision-project-pxyz"};